<template>
  <div
    class="container"
  >
    <Card
      class="activationCard"
    >
      <template v-slot:header>
        <HeadingExtraSmall>
          <Icon
            icon="premiumDiscover"
            :scale="1"
          />
          Introducing Password Manager
        </HeadingExtraSmall>
      </template>
      <template v-slot:body>
        <ParagraphBody>
          The JumpCloud Password manager is a new way for you to
          securely store and share passwords and credit card information with your team
        </ParagraphBody>
      </template>
      <template v-slot:footer>
        <div>
          <ButtonGroup
            class="activationCardButtons"
            :isFullWidth="false"
          >
            <Button
              data-test-id="PasswordManagerActivation_activateButton"
              :isLoading="isActivating"
              text="Activate Password Manager"
              @click="handleActivatePasswordManager"
            />
            <ButtonLink
              :isMatchText="false"
              text="Learn More"
              @click="handleLearnMoreClick"
            />
          </ButtonGroup>
        </div>
      </template>
    </Card>
    <LoadingOverlay
      :delayTime="0"
      hasBlur
      :visible="showLoadingOverlay"
      :zIndex="200"
    />
  </div>
</template>

<script>
import {
  Button,
  ButtonGroup,
  ButtonLink,
  Card,
  HeadingExtraSmall,
  Icon,
  LoadingOverlay,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { mapActions, mapGetters } from 'vuex';
import { notificationModuleName as notificationModule } from '@jumpcloud/ui-notifications';
import Util from 'client/util/Util';

const passwordManagerModule = 'PasswordManagerModule';

export default {
  name: 'PasswordManagerActivation',

  components: {
    Button,
    ButtonGroup,
    ButtonLink,
    Card,
    HeadingExtraSmall,
    Icon,
    LoadingOverlay,
    ParagraphBody,
  },

  Util,

  data() {
    return {
      isActivating: false,
    };
  },

  computed: {
    ...mapGetters(passwordManagerModule, {
      isEnabled: 'getPasswordManagerStatus',
    }),

    showLoadingOverlay() {
      return this.isActivating;
    },
  },

  methods: {
    ...mapActions(notificationModule, [
      'triggerErrorNotification',
      'triggerSuccessNotification',
    ]),

    ...mapActions(passwordManagerModule, ['activatePasswordManager']),

    async handleActivatePasswordManager() {
      this.isActivating = true;
      try {
        await this.activatePasswordManager();
        this.triggerSuccessNotification({ title: 'Activated', message: 'Password Manager Activated!' });
      } catch (e) {
        this.triggerErrorNotification({
          title: 'Error',
          message: 'There was a problem activating Password Manager. Please try again.',
        });
      }

      this.isActivating = false;
    },

    handleLearnMoreClick() {
      this.$options.Util.openUrl('https://jumpcloud.com/platform/password-manager');
    },
  },

};
</script>

<style scoped>
.container {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  padding: var(--jc-spacer-large);
}

.activationCard.activationCard {
  background-color: var(--jc-background-tertiary-light);
  width: 35rem;
}

.activationCardButtons.activationCardButtons {
  justify-content: flex-start;
}
</style>
